<template>
  <div class="emd-card-grid__row">
    <div class="emd-card-grid__column">
      <p class="emd-text _color_subtle _type_caption eu-mb_1">
        {{ $t('charge.detail.payment-method.cash.description') }}
      </p>
      <p class="emd-card-grid__line">
        {{ lastTransaction.description || '-' }}
      </p>
    </div>

    <DetailAt
      :updated-at="updatedAt"
      :created-at="createdAt"
    />
  </div>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodCash',

  components: {
    DetailAt: () =>
      import(
        /* webpackChunkName: "detail-at" */ '../../components/DetailAt.vue'
      )
  },

  props: {
    lastTransaction: {
      required: true
    }
  },

  computed: {
    updatedAt () {
      return {
        title: this.$t('charge.detail.payment-method.cash.updated-at'),
        date: this.lastTransaction.updated_at
      }
    },

    createdAt () {
      return {
        title: this.$t('charge.detail.payment-method.cash.created-at'),
        date: this.lastTransaction.created_at
      }
    }
  }
}
</script>
